import React, {useMemo} from 'react';
import {FlexColumnSection, FlexRowSection} from "../../../styles/globalStyles";
import {getPayForSlotMembershipType} from "@arboxappv4/shared/src/helpers/functions";
import {light, solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {t} from "i18next";
import {useSelector} from "react-redux";
import {Colors} from "@arboxappv4/shared/src/styles/Colors";
import CustomFieldsDataDisplay from "../../../components/CustomFieldsDataDisplay";

const GroupSessionDescription = (props) => {
    const { session, membershipTypeId, hideCheckIcon } = props;
    const globalLocation = useSelector(state => state.site.selectedLocation)

    const serviceMt = useMemo(() => session ? getPayForSlotMembershipType(session, membershipTypeId) : null, [session, membershipTypeId])
    const currencySymbol = useMemo(() => globalLocation?.currency_symbol, [globalLocation]);
    console.log('serviceMt',serviceMt, session, membershipTypeId)
    if(!session) return <></>

    return (
        <FlexColumnSection gap={'20px'}>
            <FlexRowSection gap={'10px'} align={'center'}>
                {serviceMt &&
                    <FlexRowSection gap={'10px'} flex={'none'}>
                        {!hideCheckIcon && <FontAwesomeIcon icon={light('check')}/>}
                        <span>{t('pay-for-slot-available')}</span>
                        <span>|</span>
                        {serviceMt.price > 0 ? <span>{currencySymbol} {serviceMt.price}</span> : <span>{t('free')}</span>}
                    </FlexRowSection>
                }
                {serviceMt && session.live_link && <FontAwesomeIcon icon={solid('circle-small')} color={Colors.siteBlack} className={'dot-icon'}/>}
                {session.live_link && <span>{t('online-session')}</span>}
                {!serviceMt && !session.live_link && <span>{t('no-group-session-information')}</span>}
            </FlexRowSection>
            <CustomFieldsDataDisplay data={session} />
            <span>{session.box_categories.bio}</span>
        </FlexColumnSection>
    );
};

export default GroupSessionDescription;